import { store } from 'shared/store';
import { receivedTrigger, receivedWidgetState } from 'shared/store/realtime-slice';
import { getCommitHash, getProtocolVersion } from 'sb-lib/env';
import { makeLog } from 'shared/utils/log';
import {
  WidgetBuildInformationData,
  WidgetData,
  WidgetDataType,
  WidgetStateData,
  WidgetTriggerData,
} from 'types';
import { handleRrwebEvent } from './rrweb-event-handler';

const log = makeLog('data-handler');

export const handleUnchunked = (data: WidgetData) => {
  if (typeof data === 'string') {
    data = JSON.parse(data);
  }

  // Support an array
  const plural = Array.isArray(data) ? data : [data];

  plural.forEach(d => {
    if (d.type === WidgetDataType.event) {
      handleRrwebEvent(d.event, d.nonce);
    } else if (d.type === WidgetDataType.buildInformation) {
      handleBuildInformation(d);
    } else if (d.type === WidgetDataType.trigger) {
      handleTrigger(d);
    } else if (d.type === WidgetDataType.widgetState) {
      handleWidgetState(d);
    } else {
      log.warn(`No handler for data type ${(d as any).type}`);
    }
  });
};

const handleBuildInformation = (data: WidgetBuildInformationData) => {
  const feHash = getCommitHash();
  log.debug(
    `Connected widget commit hash ${data.hash}, protocol version ${data.protocolVersion}`,
  );
  if (data.hash !== feHash) {
    log.warn(
      `Connected widget has a different commit hash \n widget: ${data.hash} \n frontend: ${feHash}`,
    );
  }
  const feProtocolVersion = getProtocolVersion();
  if (data.protocolVersion !== feProtocolVersion) {
    log.error(
      `Connected widget has a different protocol version \n widget: ${data.protocolVersion} \n frontend: ${feProtocolVersion}`,
    );
  }
};

const handleTrigger = (data: WidgetTriggerData) => {
  store.dispatch(receivedTrigger(data));
};

const handleWidgetState = (data: WidgetStateData) => {
  store.dispatch(receivedWidgetState(data.widgetState));
};
